<template>
  <div class="cnc-parts-carousel">
    <div class="carousel-header">
      <h2 class="carousel-title">Custom 3D Printed Parts</h2>
    </div>

    <div class="carousel-wrapper">
      <button class="carousel-arrow left-arrow" @click="prevSlide" :disabled="isAnimating">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="#16bc9c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      <div class="carousel-container" ref="carouselContainer">
        <div class="carousel-track" :style="trackStyle">
          <div class="carousel-slide" 
               v-for="(img, i) in images.slice(-4)" 
               :key="`before-${i}`"
               :style="{ flex: `0 0 ${100 / visibleSlides}%` }">
            <img :src="img.src" alt="clone" class="slide-img" />
          </div>

          <div class="carousel-slide" 
               v-for="(img, i) in images" 
               :key="i"
               :style="{ flex: `0 0 ${100 / visibleSlides}%` }">
            <img :src="img.src" :alt="img.alt" class="slide-img" />
          </div>

          <div class="carousel-slide" 
               v-for="(img, i) in images.slice(0, 4)" 
               :key="`after-${i}`"
               :style="{ flex: `0 0 ${100 / visibleSlides}%` }">
            <img :src="img.src" alt="clone" class="slide-img" />
          </div>
        </div>
      </div>

      <button class="carousel-arrow right-arrow" @click="nextSlide" :disabled="isAnimating">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9 18L15 12L9 6" stroke="#16bc9c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <div class="carousel-dots">
      <span v-for="(img, index) in images" :key="index" class="dot" :class="{ active: currentIndex === index }"
        @click="goToSlide(index)"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'printing_Part',
  data() {
    return {
      images: [
        { src: require('@/assets/product/3d/1.jpg'), alt: '3D Printed Part 1' },
        { src: require('@/assets/product/3d/2.jpg'), alt: '3D Printed Part 2' },
        { src: require('@/assets/product/3d/4.jpg'), alt: '3D Printed Part 3' },
        { src: require('@/assets/product/3d/3.jpg'), alt: '3D Printed Part 4' },
        { src: require('@/assets/product/3d/5.jpg'), alt: '3D Printed Part 5' },
        { src: require('@/assets/product/3d/6.jpg'), alt: '3D Printed Part 6' },
        { src: require('@/assets/product/3d/7.jpg'), alt: '3D Printed Part 7' },
        { src: require('@/assets/product/3d/8.jpg'), alt: '3D Printed Part 8' },
        { src: require('@/assets/product/3d/9.jpg'), alt: '3D Printed Part 9' },
        { src: require('@/assets/product/3d/10.jpg'), alt: '3D Printed Part 10' },
        { src: require('@/assets/product/3d/11.jpg'), alt: '3D Printed Part 11' },
        { src: require('@/assets/product/3d/12.jpg'), alt: '3D Printed Part 12' },
        { src: require('@/assets/product/3d/13.jpg'), alt: '3D Printed Part 13' },
        { src: require('@/assets/product/3d/14.jpg'), alt: '3D Printed Part 14' },
       
      ],
      currentIndex: 0,
      slideWidth: 0,
      visibleSlides: 4.2, 
      isAnimating: false,
      autoPlayInterval: null,
      intervalTime: 3000
    }
  },
  computed: {
    trackStyle() {
      return {
        transform: `translateX(-${(this.currentIndex + 4) * this.slideWidth}px)`,
        transition: this.isAnimating ? 'transform 0.5s ease-in-out' : 'none'
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.calculateSlides();
      this.startAutoPlay();
    });
    window.addEventListener('resize', this.calculateSlides);
  },
  beforeUnmount() { 
    window.removeEventListener('resize', this.calculateSlides);
    this.stopAutoPlay();
  },
  methods: {
    calculateSlides() {
      const width = window.innerWidth;
      
      if (width >= 1024) {
        this.visibleSlides = 4.2; 
      } else if (width >= 768) {
        this.visibleSlides = 2.2; 
      } else {
        this.visibleSlides = 1.2; 
      }

      if (this.$refs.carouselContainer) {
        this.slideWidth = this.$refs.carouselContainer.offsetWidth / this.visibleSlides;
      }
    },
    
    nextSlide() {
      if (this.isAnimating) return;
      this.currentIndex++;
      this.animate();
    },
    prevSlide() {
      if (this.isAnimating) return;
      this.currentIndex--;
      this.animate();
    },
    goToSlide(index) {
      if (this.isAnimating) return;
      this.currentIndex = index;
      this.animate();
    },
    animate() {
      this.isAnimating = true;
      this.startAutoPlay();
      setTimeout(() => {
        if (this.currentIndex >= this.images.length) {
          this.currentIndex = 0;
        }
        if (this.currentIndex < 0) {
          this.currentIndex = this.images.length - 1;
        }
        this.isAnimating = false;
      }, 500);
    },
    startAutoPlay() {
      this.stopAutoPlay();
      this.autoPlayInterval = setInterval(() => this.nextSlide(), this.intervalTime);
    },
    stopAutoPlay() {
      if (this.autoPlayInterval) clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }
}
</script>

<style scoped>
.cnc-parts-carousel {
  background: #f0f4f5;
  padding: 40px 20px;
  text-align: center;
}

.carousel-title {
  font-size: clamp(24px, 4vw, 32px);
  margin: 0 0 30px;
}

.carousel-wrapper {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.8); 
  border: 1px solid #eee;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 9;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.left-arrow {
  left: 0px;
}

.right-arrow {
  right: 0px;
}

@media (min-width: 768px) {
  .left-arrow {
    left: -20px;
  }
  .right-arrow {
    right: -20px;
  }
}

.carousel-container {
  width: 100%;
  overflow: hidden;
}

.carousel-track {
  display: flex;
}

.carousel-slide {
  padding: 0 6px;
  box-sizing: border-box;
}

.slide-img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-radius: 6px;
  background: #eee;
}

.carousel-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
  /* ✨ 移除 flex-wrap: wrap; 强制在一行显示 */
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #b2e9da;
  cursor: pointer;
}

.dot.active {
  background: #16bc9c;
}

/* ✨ 当屏幕小于 480px 时（大概率一排放不下17个点），直接隐藏小圆点 */
@media (max-width: 480px) {
  .carousel-dots {
    display: none;
  }
}
</style>